import React from 'react';
import ImageSucces from '../../../../../../assets/images/image-success.png'; 
import useLangTranslation from '../../../../../customHooks/languageProvider';
// assets/images/image-success.png';

const SendPinCode = () => {
    const { getLangTranslation } = useLangTranslation();
    return (
        <div className="container">
            <div className="auth-wrapper">
                <div className="auth-inner text-center">
                    <div>
                        <img src={ImageSucces} alt='' />
                    </div>
                    <h5 className="text-center mb-9">{getLangTranslation("PIN_CODE_RECOVERY_SUCCESS", "An email was sent to your registered email address with your Pin Code")}</h5>

                    <button type="button" className="btn btn-primary">
                        <span className="btn-upper-case">{getLangTranslation("CHILD_LOCATE_GOT_IT", "GOT IT")}</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SendPinCode;